// @ts-nocheck
/* Port of views/dashboard/module/DispositionFormsTimingAclModal.js — byte-identical. */
import React, { useEffect, useState } from 'react';
import {
  ALLOW_FOLLOWUPS_ACL_OPTION,
  CUSTOM_TIMING_ACL_OPTION,
  normalizeDispositionTimingOptions,
} from '@/utilities/dispositionFormsAcl';
import {
  AclSettingsModal,
  AclModalSection,
  AclModalOptionCheck,
  FaFileAlt,
} from '@/features/acl-settings/aclSettingsUi';

const DispositionFormsTimingAclModal = ({
  show,
  onHide,
  initialOptions = [],
  optionsConfigured = false,
  onSave,
  limitedByParent = false,
  canGrantCustomTiming = true,
  canGrantFollowUps = true,
}) => {
  const [customTimingEnabled, setCustomTimingEnabled] = useState(false);
  const [followUpsEnabled, setFollowUpsEnabled] = useState(false);

  useEffect(() => {
    if (!show) return;

    const options = normalizeDispositionTimingOptions(
      Array.isArray(initialOptions) ? initialOptions : [],
    );

    if (!optionsConfigured) {
      setCustomTimingEnabled(canGrantCustomTiming);
      setFollowUpsEnabled(false);
    } else {
      setCustomTimingEnabled(options.includes(CUSTOM_TIMING_ACL_OPTION));
      setFollowUpsEnabled(options.includes(ALLOW_FOLLOWUPS_ACL_OPTION));
    }
  }, [show, initialOptions, optionsConfigured, canGrantCustomTiming, canGrantFollowUps]);

  const handleReset = () => {
    setCustomTimingEnabled(false);
    setFollowUpsEnabled(false);
  };

  const handleSave = () => {
    const next = [];
    if (customTimingEnabled && canGrantCustomTiming) {
      next.push(CUSTOM_TIMING_ACL_OPTION);
    }
    if (followUpsEnabled && canGrantFollowUps) {
      next.push(ALLOW_FOLLOWUPS_ACL_OPTION);
    }
    onSave(next);
    onHide();
  };

  const canSaveAnything = canGrantCustomTiming || canGrantFollowUps;

  return (
    <AclSettingsModal
      show={show}
      onHide={onHide}
      title="Disposition Forms — Options"
      icon={FaFileAlt}
      description="Configure which disposition form capabilities users with this ACL can manage."
      limitedByParent={limitedByParent}
      onSave={handleSave}
      onReset={handleReset}
      saveDisabled={!canSaveAnything}
    >
      <AclModalSection
        icon={FaFileAlt}
        title="Custom timing"
        subtitle="Grant permission to set a custom disposition open / wrap-up duration."
      >
        {!canGrantCustomTiming ? (
          <p className="acl-modal-empty">
            You do not have permission to grant custom timing on Disposition Forms.
          </p>
        ) : (
          <AclModalOptionCheck
            id="disposition-custom-timing"
            label="Give custom timing"
            description="Allow configuring a custom wrap-up duration for disposition forms"
            checked={customTimingEnabled}
            onChange={(e) => setCustomTimingEnabled(e.target.checked)}
          />
        )}
      </AclModalSection>

      <AclModalSection
        icon={FaFileAlt}
        title="Allow follow-ups"
        subtitle="Grant permission to enable follow-up scheduling on disposition forms."
      >
        {!canGrantFollowUps ? (
          <p className="acl-modal-empty">
            You do not have permission to grant follow-ups on Disposition Forms.
          </p>
        ) : (
          <AclModalOptionCheck
            id="disposition-allow-follow-ups"
            label="Allow follow-ups"
            description="Allow enabling follow-up date and time on disposition forms"
            checked={followUpsEnabled}
            onChange={(e) => setFollowUpsEnabled(e.target.checked)}
          />
        )}
      </AclModalSection>
    </AclSettingsModal>
  );
};

export default DispositionFormsTimingAclModal;
